import { type DisclosureLink } from '../../components'

interface ApexDisclosure {
  disclosureId: string
  disclosureName: string
  disclosureUri: string
}

const removeNonUniqueAndAggregateUrls = (disclosures: ApexDisclosure[]): ApexDisclosure[] =>
  Object.values(
    disclosures.reduce<Record<string, ApexDisclosure>>((acc, { disclosureName, disclosureUri, ...rest }) => {
      if (!acc[disclosureUri]) {
        acc[disclosureUri] = { disclosureName, disclosureUri, ...rest }
      }
      return acc
    }, {}),
  )

export const getMultiDisclosures = (
  disclosures: Record<string, string>,
  apexDisclosures: ApexDisclosure[],
): {
  title: string
  helper: string
  expanded: string
  links: DisclosureLink[]
  name: string
}[] => {
  const egwaLinks: DisclosureLink[] = [
    {
      text: 'Investment Advisory Agreement',
      url: disclosures.investmentAdvisoryAgreement,
    },
    {
      text: 'ADV Part 2A & 2B',
      url: disclosures.advPart2A2b,
    },
    {
      text: 'Customer Relationship Summary',
      url: disclosures.customerRelationshipAgreement,
    },
    {
      text: 'Privacy Notice',
      url: disclosures.privacyPolicyAdvisors,
    },
    {
      text: 'Tax Certification for US Persons',
      url: disclosures.taxCertification,
    },
  ]

  const apexLinks: DisclosureLink[] = removeNonUniqueAndAggregateUrls(apexDisclosures).map((e) => {
    return {
      text: e.disclosureName,
      url: e.disclosureUri,
    }
  })

  return [
    {
      title: 'Evergreen Wealth Advisors',
      helper:
        'Investment Advisory Agreement, ADV Part 2A & 2B, Customer Relationship Summary, Privacy Notice, Tax Certification for US Persons',
      expanded: '',
      links: egwaLinks,
      name: 'egwa',
    },
    {
      title: 'Apex Account Agreements',
      helper: 'Customer Agreement, Privacy Policy, and Form CRS',
      expanded: '',
      links: apexLinks,
      name: 'apex',
    },
  ]
}

export const getInvestmentsDisclosures = (
  disclosures: Record<string, string>,
  apexDisclosures: ApexDisclosure[],
  accountType?: 'brokerage' | 'traditional',
): {
  title: string
  helper: string
  expanded: string
  links: DisclosureLink[]
  name: string
}[] => {
  const egwaLinks: DisclosureLink[] = [
    {
      text: 'Investment Advisory Agreement',
      url: disclosures.investmentAdvisoryAgreement,
    },
    {
      text: 'ADV Part 2A & 2B',
      url: disclosures.advPart2A2b,
    },
    {
      text: 'Customer Relationship Summary',
      url: disclosures.customerRelationshipAgreement,
    },
    {
      text: 'Privacy Notice',
      url: disclosures.privacyPolicyAdvisors,
    },
    {
      text: 'Tax Certification for US Persons',
      url: disclosures.taxCertification,
    },
  ]

  const apexLinks: DisclosureLink[] = removeNonUniqueAndAggregateUrls(apexDisclosures).map((e) => {
    return {
      text: e.disclosureName,
      url: e.disclosureUri,
    }
  })

  let apexHelper = 'IRA Customer Agreement, Privacy Policy, and Form CRS'
  if (accountType === 'brokerage') {
    apexHelper = 'Customer Agreement, Privacy Policy, and Form CRS for Brokerage Account'
  }

  return [
    {
      title: 'Evergreen Wealth Advisors',
      helper:
        'Investment Advisory Agreement, ADV Part 2A & 2B, Customer Relationship Summary, Privacy Notice, Tax Certification for US Persons',
      expanded: '',
      links: egwaLinks,
      name: 'egwa',
    },
    {
      title: 'Apex Account Agreements',
      helper: apexHelper,
      expanded: '',
      links: apexLinks,
      name: 'apex',
    },
  ]
}
